import React, { useState, useEffect } from "react";
import { MapPin } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import LoadingCircle from "../../components/Common/LoadingCircle";
import LandingPageHeader from "../../components/LandingPage/LandingPageHeader";
import AboutWelcomeNote from "../Common/AboutWelcomeNote";
import AboutWelcomeEvent from "../Common/AboutWelcomeEvent";

const About = ({ bgColor = "bg-white" }) => {
  const [activeTab, setActiveTab] = useState("welcome");
  const [loading, setLoading] = useState(true);

  const tabs = [
    { id: "welcome", label: "Welcome Note" },
    { id: "event", label: "About Event" },
  ];

  useEffect(() => {
    setLoading(false);
  }, []);

  if (loading) {
    return (
      <section id="experience" className="py-20 flex flex-col items-center justify-center min-h-[400px]">
        <LoadingCircle size="lg" />
        <p className="mt-4 text-slate-400 font-mono text-[10px] uppercase tracking-widest animate-pulse">
          Retrieving  Data...
        </p>
      </section>
    );
  }

  return (
    <section 
      id="about" 
      className={`py-6 md:py-10 scroll-mt-24 lg:scroll-mt-44 ${bgColor}`}>
      {/* Header Section */}
        <LandingPageHeader 
          icon={MapPin} 
          title="About Us" 
          subtitle="Learn more about our event" 
          center={true} 
        />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 ">
        {/* Navigation Tabs */}
        <div className="flex justify-center mb-10">
          <div className="inline-flex bg-slate-100 dark:bg-slate-800 p-1 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`relative px-6 py-2 text-xs md:text-sm font-bold transition-all duration-300 rounded-lg ${
                  activeTab === tab.id
                    ? "text-white"
                    : "text-slate-500 hover:text-slate-700 dark:hover:text-slate-300"
                }`}
              >
                {activeTab === tab.id && (
                  <motion.div
                    layoutId="activeTab"
                    className="absolute inset-0 bg-[#0F172A] rounded-lg"
                    transition={{ type: "spring", bounce: 0.15, duration: 0.5 }}
                  />
                )}
                <span className="relative z-10">{tab.label}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Content Area - Ditingkatkan tingginya agar stabil */}
        <div className="relative min-h-[600px] md:min-h-[700px]">
          <AnimatePresence mode="wait">
            <motion.div
              key={activeTab}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.3 }}
            >
              {activeTab === "welcome" ? (
                <AboutWelcomeNote />
              ) : (
                <AboutWelcomeEvent />
              )}
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </section>
  );
};


export default About;